var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.8 10.6c0-3.1 2.5-5.7 5.7-5.7h11M39.7 12.1v12M32.5 5l7.1 7.1M31.6 6.2V13h7.1M15.4 16.6l5.4 5.5-5.4 5.5M19.3 22.1H7.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 2.8,
    cy: 22.1,
    r: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M30.7 35.7v2.9M35.3 29.9h4.3v7.4h-4.3zM21.7 29.9h4.5v7.4h-4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportCsv);
export default __webpack_public_path__ + "static/media/exportCsv.1f7b49f7243cc678c065379805d76e8e.svg";
export { ForwardRef as ReactComponent };